import { styled } from 'styled-components';

export const Root = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizes.sm};
  width: 100%;
  min-height: 56px;
  padding: 0 ${({ theme }) => theme.sizes.md};
  border: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.secondary500};
  color: ${({ theme }) => theme.colors.neutral};
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary600};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary300};
    outline-offset: 2px;
  }
`;

export const TriggerIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const TriggerLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: 700;
  line-height: 1.3;
`;

export const TriggerChevron = styled.span<{ $open?: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const Menu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 20;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.neutral100};
  background-color: ${({ theme }) => theme.colors.neutral};
  box-shadow: 0 12px 32px rgba(35, 67, 124, 0.14);
`;

export const Item = styled.button`
  display: flex;
  width: 100%;
  gap: ${({ theme }) => theme.sizes.md};
  padding: ${({ theme }) => theme.sizes.sm};
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral50};
  }

  &:focus-visible {
    outline: none;
    background-color: ${({ theme }) => theme.colors.neutral50};
  }

  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.neutral100};
  }
`;
